
import fieldMixin from "@/mixins/field"

export default fieldMixin.extend({
  props: {
    label: { type: String, required: true },
  },
})
